import { Alert, AlertTitle, Snackbar } from '@mui/material'
import { memo, useEffect, useState } from 'react'
import { useNotification } from '../hooks/use-notification'
import slicesNotifications from '../slices/notifications'
import { useDispatch, useSelector } from '../store'

const Notification = memo((props) => {
    const dispatch = useDispatch()

    const [state, setState] = useState({
        snackbarOpen: true,
        notification: null,
        autoHideDuration: null
    })

    const newNotificationsRedux = useSelector(
        (state) => state.notifications.items
    )

    const { snackbarOpen, notification, autoHideDuration } = state

    const notificationContext = useNotification()

    const notifications = [
        ...newNotificationsRedux,
        ...notificationContext.notifications
    ]

    const fadeOutOldState = () => {
        setState((oldState) => {
            setTimeout(() => {
                notificationContext.removeNotification(
                    oldState.notification.key
                )

                dispatch(
                    slicesNotifications.removeEvent(oldState.notification.key)
                )
            }, 500)

            const newState = {
                ...oldState,
                snackbarOpen: false
            }

            return newState
        })
    }

    useEffect(() => {
        if (notification && !notifications.length) {
            setState({
                notification: false,
                autoHideDuration: null
            })
            return
        }

        if (!notifications.length) {
            return false
        }

        if (notification && notification.key === notifications[0].key) {
            return false
        }

        let autoHideDuration = notifications[0].type === 'error' ? 8000 : 5000

        setState({
            snackbarOpen: true,
            notification: notifications[0],
            autoHideDuration
        })
    }, [notifications])

    const handleClose = () => {
        if (!notification) return false

        fadeOutOldState(true)
    }

    const handleOnSnackBarEventClose = (event) => {
        if (event !== null) return false

        fadeOutOldState(true)
    }

    if (!notification) {
        return <></>
    }
    return (
        <Snackbar
            className="noPrint"
            open={snackbarOpen}
            direction="down"
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            autoHideDuration={autoHideDuration}
            onClose={handleOnSnackBarEventClose}
        >
            <Alert
                onClose={handleClose}
                severity={notification.type}
                color={notification.type}
                variant="filled"
                sx={{ width: '100%' }}
            >
                {notification.title !== null && (
                    <AlertTitle>{notification.title}</AlertTitle>
                )}
                {notification.message}
            </Alert>
        </Snackbar>
    )
})

export default Notification
